import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from "@angular/router";

import { AlertService } from 'src/app/_services/alert.service';
import { BookingPostingErrorTypes } from 'src/app/enums';
import { Helpers } from 'src/app/_models/helpers';
import { CryptoService } from 'src/app/_services/services';
import Utils from 'src/app/utils';
import { BookingServiceProvider } from 'src/app/_services/booking.service';
import { LoadingService } from 'src/app/_services/loading.service';
import { MaterialModule } from 'src/app/material.module';
import { SharedModule } from 'src/app/shared.module';


@Component({
  selector: 'app-booking-complete',
  templateUrl: './booking-complete.component.html',
  standalone: true, // Required for Angular 18's new standalone components
  imports: [
    SharedModule,
    MaterialModule
  ]
  // animations: [routerTransition()],
  // host: { '[@routerTransition]': '' }
})
export class BookingCompleteComponent implements OnInit {
  bookingReceiptNumber: any;
  createdDateTime: any;
  mode: string;
  ButtonName: string = ""
  DownloadButtonVisible: boolean = false;
  DownloadButtonDisable: boolean = false;
  PendingAgreement: boolean = false;
  fileUrl;
  isAutoApprove: boolean = false;
  bookingID: string;
  splits: any;
  isSplit: boolean;
  documentNumber: string;
  constructor(
    private route: ActivatedRoute,
    public bookingService: BookingServiceProvider,
    private alertService: AlertService,
    public cryptoService: CryptoService,
    private blockUI: LoadingService
  ) {

  }

  ngOnInit() {
    // this.events.publish("event:blockUnblockLoctionChange");
    this.blockUI.stop();
    this.route.params.subscribe(params => {
      Helpers.LogInfo(params);
      if (params['splits'] && params['splits'] != 'undefined') {
        this.splits = JSON.parse(params['splits']);
        this.splits.forEach((split) => {
          // split.CreatedDateTime = Utils.formatDateWithAmPm(new Date(split.CreatedDateTime));
          split.CreatedDateTime = Utils.formatAndconvertUtcToLocal(split.CreatedDateTime);

        })
      }
      if (params['isSplit']) {
        this.isSplit = params['isSplit'] == 'true';
      }
      if (params['mode']) {
        this.mode = params['mode'];
      }
      if (params['isAutoApprove']) {
        this.isAutoApprove = params['isAutoApprove'];
      }
      if (params['BookingID']) {
        this.bookingID = params['BookingID'];
      }
      if (params['bookingReceiptNumber']) {
        this.bookingReceiptNumber = params['bookingReceiptNumber'];
      }
      if (params['createdDateTime']) {
        this.createdDateTime = Utils.formatAndconvertUtcToLocal(params['createdDateTime']);
      }
      if (params['documentNumber']) {
        this.documentNumber = params['documentNumber'];
        if (this.mode == 'Order') {
          this.documentNumber = this.documentNumber.replace('S', '').replace('-', '');
          this.documentNumber = this.addHyphenAfterFirstThreeChars(this.documentNumber);
        }
      }
      if (params['Btn']) {
        this.ButtonName = params['Btn'];
      }
      else {
        if (this.mode == 'Prepay') {
          this.ButtonName = 'Prepay';
        }
        else if (this.mode == 'Book') {
          this.ButtonName = 'Booking';

        }
        else if (this.mode == 'Quote') {
          this.ButtonName = 'Quote';
        }

        if (params['PendingAgreement']) {
          this.PendingAgreement = params['PendingAgreement'] === 'true' ? true : false;
        }

      }

      let ProUserRights = this.cryptoService.dencryptString(localStorage.getItem('ProUser'));
      if (ProUserRights.toLowerCase() === 'true' && (this.isAutoApprove || this.PendingAgreement || this.mode == 'Quote')) {
        this.DownloadButtonVisible = true;
      } else {
        this.DownloadButtonVisible = false;
      }


      // if (params['errorType'] && (params['mode'] == "Prepay" || params['mode'] == "Book")) {
      if (params['errorType']) {
        let errorType = params['errorType'].split(',');
        this.DownloadButtonDisable = true;
        if (errorType && errorType.length > 0) {
          let errorMessage = '';
          errorType.forEach((e) => {
            if (e == BookingPostingErrorTypes.PrintFailure) {
              errorMessage += "Unable to print the PDF. Please go to AGRIS Sales Review or contact your administrator to retry. "
            }
            if (e == BookingPostingErrorTypes.VoidFailure) {
              errorMessage += 'The ' + this.ButtonName + ' has been successfully added but the quote was not successfully voided. Please review the failed quote in Sales Review for more details. '
            }
            if (e == BookingPostingErrorTypes.PostingFailure) {
              errorMessage += "Unable to Create the " + this.ButtonName + " . Please go to AGRIS Sales Review or contact your administrator to retry. "
            }
          });
          return this.alertService.error(errorMessage);
        }
      }

    });

  }


  DownloadPDF(bookingId, documentNumber: string = null) {
    this.documentNumber = documentNumber ? documentNumber : this.documentNumber;
    if (this.isSplit) {
      bookingId = encodeURIComponent(this.cryptoService.encryptString(bookingId.toString()));
    }

    this.blockUI.start();
    // this.gatewayService.printAndDownloadBooking(this.bookingReceiptNumber, this.isAutoApprove == false , (response: any) => {     
    //   if (response) {


    let pdfLink = `${Utils.GetSalesReviewRemoteServer()}/BookingsV2/GetPrintForm?id=${bookingId}&isPending=${this.isAutoApprove}`;
    let encodeURI = encodeURIComponent(pdfLink)
    console.log("pdfLink =>", pdfLink);
    // this.bookingService.getPdfFromURL(encodeURI,this.bookingReceiptNumber).then((response) => {   
    this.bookingService.getPdfFromURL(encodeURI, this.documentNumber).then((response) => {
      console.log(response);
      const base64Pdf = this.arrayBufferToBase64(response);
      const message = { type: 'DOWNLOAD_PDF', data: base64Pdf, name: this.documentNumber };
      window.parent.postMessage(message, "*");

      //this.documentNumber = "";
      this.blockUI.stop();
    }).catch((error) => {

      console.log(error);
      this.blockUI.stop();
      this.alertService.error(error.Message);
      this.blockUI.stop();

    });
  }
  postMessageToAllParents(message: any, origin: string = '*'): void {
    let currentWindow: Window = window;

    while (currentWindow !== currentWindow.parent) {
      currentWindow = currentWindow.parent;
      currentWindow.postMessage(message, origin);
    }

    // Optionally, send a message to the top window itself
    currentWindow.postMessage(message, origin);
  }
  arrayBufferToBase64(buffer: ArrayBuffer): string {
    let binary = '';
    const bytes = new Uint8Array(buffer);
    const len = bytes.byteLength;

    for (let i = 0; i < len; i++) {
      binary += String.fromCharCode(bytes[i]);
    }

    return window.btoa(binary);
  }
  addHyphenAfterFirstThreeChars(input: string): string {
    if (input.length <= 3) { return input; }
    const firstPart = input.slice(0, 3);
    const remainingPart = input.slice(3);
    return `${firstPart}-${remainingPart}`;
  }
}
